import React, { useMemo, useState, useCallback } from 'react'
import { Outlet } from 'react-router-dom'

import SidebarMenu from '@/components/regions/SidebarMenu'
import { useCardsHelper } from '@/hooks/useCardsHelper'
import useUrlParameters from '@/hooks/useUrlParameters'

import { PageContent, PageLayout } from './styles'

const Page: React.FC = () => {
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false)
  const { activeCards } = useCardsHelper()
  const { query } = useUrlParameters()

  const isZoomedMode = useMemo(() => query.zoomed === 'true', [query.zoomed])

  const isMenuHidden = useMemo(
    () => (activeCards[1]?.page?.isFullWidthWhenExpanded && activeCards[1]?.page?.expanded) || isZoomedMode,
    [activeCards[1]?.page?.isFullWidthWhenExpanded, activeCards[1]?.page?.expanded, isZoomedMode]
  )

  const onCollapse = useCallback(() => {
    setIsMenuCollapsed((prev) => !prev)
  }, [setIsMenuCollapsed])

  const pageWidth = useMemo(() => {
    const menuWidth = isMenuCollapsed ? 50 : 285
    return (isMenuHidden || isZoomedMode) ? '100vw' : `calc(100vw - ${menuWidth}px)`
  }, [isMenuCollapsed, isMenuHidden, isZoomedMode])

  return (
    <PageLayout>
      <SidebarMenu isCollapsed={isMenuCollapsed} onCollapse={onCollapse} />
      <PageContent $width={pageWidth}>
        <Outlet />
      </PageContent>
    </PageLayout>
  )
}

export default Page
